import { render } from "./ProductPickerSearch.vue?vue&type=template&id=381655e2"
import script from "./ProductPickerSearch.vue?vue&type=script&lang=js"
export * from "./ProductPickerSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__